import { memo, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'
import { formatShiftDuration } from 'utils/shiftDuration'

/** Durasi shift yang masih berjalan, diperbarui tiap menit (hanya teks ini yang re-render). */
const LiveDuration = ({ start }) => {
  const { formatMessage } = useIntl()
  const [now, setNow] = useState(() => dayjs())

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(dayjs())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  return formatShiftDuration(start, now, formatMessage) || '-'
}

export default memo(LiveDuration)
